import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';

type Result = ModelHookResult<
	undefined,
	{
		onTokenError: () => void;
		onTokenInvalid: () => void;
	}
>;

export function useTokenError(): Result {
	const [, mutations] = useContributionsPageState();
	const { translate } = useI18n();

	const track = useTracking();

	const onTokenError = () => {
		void track('sponsor_cc_update_general_error');

		mutations.handlePaymentUpdateError({
			message: translate('fe.errors.generic_try_again'),
		});
	};
	const onTokenInvalid = () => {
		void track('sponsor_cc_update_general_error');
		mutations.handlePaymentUpdateError({});
	};
	return {
		actions: {
			onTokenError,
			onTokenInvalid,
		},
	};
}
